import React from "react";

export function GeometryBackground({ scrollProgress }) {
  const rotation = scrollProgress * 360;
  const slowRotation = scrollProgress * 180;

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{ zIndex: 0 }}>
      {/* Icosahedron rings */}
      <div
        className="absolute"
        style={{
          top: "12%",
          right: "8%",
          width: "280px",
          height: "280px",
          transformStyle: "preserve-3d",
          transform: `perspective(800px) rotateX(${rotation * 0.3}deg) rotateY(${rotation * 0.5}deg)`,
          opacity: 0.08,
        }}
      >
        {[0, 60, 120].map((angle) => (
          <div
            key={angle}
            className="absolute inset-0 rounded-full"
            style={{
              border: "1px solid oklch(0.7 0.08 280)",
              transform: `rotateY(${angle}deg)`,
            }}
          />
        ))}
      </div>

      {/* Torus rings */}
      <div
        className="absolute"
        style={{
          bottom: "15%",
          left: "5%",
          width: "220px",
          height: "220px",
          transformStyle: "preserve-3d",
          transform: `perspective(600px) rotateX(${slowRotation * 0.4}deg) rotateZ(${rotation * 0.2}deg)`,
          opacity: 0.06,
        }}
      >
        {[0, 30, 60, 90, 120, 150].map((angle) => (
          <div
            key={angle}
            className="absolute inset-0 rounded-full"
            style={{
              border: "1px solid oklch(0.8 0.06 90)",
              transform: `rotateY(${angle}deg)`,
            }}
          />
        ))}
      </div>

      {/* Floating particles */}
      {Array.from({ length: 15 }).map((_, i) => {
        const x = 8 + (i * 41) % 80;
        const y = 5 + (i * 47) % 85;
        const size = 2 + (i % 3);
        const drift = Math.sin((scrollProgress * Math.PI * 2) + i * 0.8) * 20;
        const colors = [
          "oklch(0.75 0.08 280 / 0.2)",
          "oklch(0.78 0.06 160 / 0.15)",
          "oklch(0.82 0.06 90 / 0.2)",
        ];
        return (
          <div
            key={`p-${i}`}
            className="absolute rounded-full"
            style={{
              left: `${x}%`,
              top: `${y}%`,
              width: `${size}px`,
              height: `${size}px`,
              background: colors[i % 3],
              transform: `translateY(${drift}px)`,
            }}
          />
        );
      })}
    </div>
  );
}
